import * as React from "react";
import Image from "next/image";

import { Grid, Typography, makeStyles } from "@material-ui/core";
import { useRouter } from "next/router";
import uuid from "react-uuid";
import Empty from "../../../static/Empty";
import Link from "next/link";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#fff",
    margin: "10px auto",
    padding: "20px 10px",
    border: "solid 1px #B6B3B3",
  },
  p: {
    padding: 10,
  },
  t1: {
    color: "#0A369D",
    fontWeight: "bold",
    fontSize: 18,
  },
  t2: {
    color: "#0A369D",
    fontSize: 14,
    fontFamily: "Vazir",
  },
  t3: {
    color: "#292929",
    fontSize: 14,
    fontFamily: "Vazir",
  },
  image: {
    borderRadius: "100%",
    border: "solid 1px #aaa !important",
  },
  link: {
    cursor: "pointer",
  },
}));

const Branches = ({ data }) => {
  const classes = useStyles();
  const router = useRouter();

  if (data?.branches?.length > 0 || data?.operating_areas?.length > 0) {
    return (
      <Grid container className={classes.container}>
        {data.branches.length > 0 && (
          <>
            <Grid item xs={12} className={classes.p}>
              <Typography variant="h2" className={classes.t1}>
                شعب
              </Typography>
            </Grid>
            {data.branches.map((item) => (
              <Link
                href={{
                  pathname: "/organizations/charities/[slug]",
                  query: { slug: item.slug },
                }}
              >
                <Grid item xs={6} className={classes.link} key={uuid()}>
                  <Grid container justify="center" alignItems="center">
                    <Grid item xs={2} className={classes.p}>
                      <Image
                        src={item.logo}
                        blurDataURL={item.logo}
                        placeholder="blur"
                        width={50}
                        height={50}
                        className={classes.image}
                        alt={item.name}
                      />
                    </Grid>
                    <Grid item xs={10}>
                      <p className={classes.t2}>{item.name}</p>
                    </Grid>
                  </Grid>
                </Grid>
              </Link>
            ))}
          </>
        )}
        {data.operating_areas.length > 0 && (
          <>
            <Grid item xs={12} className={classes.p}>
              <Typography variant="h2" className={classes.t1}>
                محدوده فعالیت عملیاتی
              </Typography>
            </Grid>
            {data.operating_areas.map((item, i) => (
              <Grid item xs={12} key={uuid()}>
                <Grid container justify="center" alignItems="center">
                  <Grid item xs={12} className={classes.p}>
                    <Typography variant="h3" className={classes.t3}>
                      {i + 1}. {item.state_name} _ {item.city_name}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    );
  }
  return <Empty />;
};

export default Branches;
